import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import {
  getCompletesMinePosts,
  getMinePosts,
  getUmbrellaCancelledMinePosts,
} from "../../../../../../redux/posts/action";
import { useNavigate } from "react-router-dom";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import GetRemainDays from "../../PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetRemainDays";
import GetStatus from "../../PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetStatus";
import { useRouteBaseStateContext } from "../../../../../../Context/RouteBaseStateContext";
import CustomeCircularProgressbar from "../../../../../Common/CustomeLabel/CustomeCircularProgressbar";
import { getPercentage } from "../../../../../Common/FewCommonMethods";
import { decodeHtml } from "../../../../../../assests/extention/commonfunction";

export default function CancelledUmbrellaProjects() {
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();
  // const completedumbrellapostlistmine = useSelector(
  //   ({ posts: { completedumbrellapostlistmine } }) =>
  //     completedumbrellapostlistmine,
  // );

const [completedumbrellapostlistmine, setUmbrellaPosts] = useState([]);

useEffect(() => {
  let mounted = true;

  const fetchData = async () => {
    const res = await dispatch(getUmbrellaCancelledMinePosts(1, 4));
    if (mounted && res?.status) {
      setUmbrellaPosts(res.response || []);
    }
  };

  fetchData();

  return () => {
    mounted = false;
  };
}, [dispatch]);


  return (
    <>
      <div className="posted-project">
        {/* <h4>
          Completed Umbrella projects ({completedumbrellapostlistmine?.length})
        </h4> */}
        {/* <h4>Completed Umbrella projects (0)</h4> */}
        <div className="recent-post">
          {completedumbrellapostlistmine.length == 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            completedumbrellapostlistmine.map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-2 col-6 mx-auto">
                  <CustomeCircularProgressbar
                    percentage={getPercentage(
                      item?.total_milestone,
                      item?.completed_milestone,
                    )}
                  />
                </div>
                <div className="col-md-7 padding-zero">
                  <h3>{decodeHtml(item.ambrella_title)}</h3>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <th>Milestones completed</th>
                        <th>Completed sub projects</th>
                        <th>Total experts</th>
                        <th>Total cost</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {item?.completed_milestone} out of {item?.total_milestone}
                          </td>
                          <td>
                            {item?.completed_sub_projects} out of {item?.total_sub_projects}
                          </td>
                          <td>{item?.hired_experts || 0}</td>
                          <td>SAR {item?.total_price || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <button
                  onClick={() =>
                    navigate(
                      `/${lan}/dashboard/myorders/umrellaproject/${item.id}`,
                    )
                  }
                  className="btn"
                >
                  View details
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            ))
            // <PostNotFound title={'Completed Umbrella projects Not Found'} />
          )}
        </div>
      </div>
    </>
  );
}
